import React, { useState, useEffect } from 'react';
import { AppContext } from './contexts/AppContext';

const AppProvider = (props) => {

    const [appState, setAppState] = useState({
    });

    // Initialize the auth system upon load, and do a silent authentication.
    useEffect(async () => {
    }, []);

    // helper method to combine new state with previous
    const updateAppState = (state) => {
        setAppState(prevState => ({
            ...prevState,
            ...state
        }));
    };

    return (
        <AppContext.Provider value={appState}>
            {props.children}
        </AppContext.Provider>
    );
};

export default AppProvider;